import React from "react";
import { multilanguage } from "redux-multilanguage";
import { connect } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { setValue, sendSubscription } from "../../../../redux/actions/subscriptionActions";

const SubscribeEmail = ({ strings, subscription, setValue, sendSubscription }) => {
    const { addToast } = useToasts();
    return (
        <div className="subscribe-form">
            <div className="mc-form">
                <div>
                    <input
                        className="email"
                        style={{ border:"none", borderBottomColor: subscription.email_error ? "red" : "#ffffff" }}
                        value={subscription.email}
                        onChange={(e) => setValue("email", e.target.value)}
                        type="email"
                        placeholder={strings['footer']['subscribe']['placeholder']}
                    />
                    {
                        subscription.email_error ?
                            <small style={{ color: "red" }}>{subscription.email_helpertext}</small> : null
                    }
                </div>
                <div className="clear">
                    <button disabled={subscription.isFetching} onClick={() => sendSubscription([
                        {
                            key: "email",
                            value: subscription.email,
                            required: true
                        }
                    ], addToast, strings)} style={{ color: "#ffffff" }} className="button">
                        {subscription.isFetching ? <i className="fa fa-spinner fa-spin"></i> : strings['footer']['subscribe']['button']}
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        subscription: state.subscription
    };
};

export default connect(mapStateToProps, {
    setValue,
    sendSubscription
})(multilanguage(SubscribeEmail));


